module.exports = __webpack_public_path__ + "static/img/Frame14.229c609e.png";